import { Form, Select } from '@arco-design/web-react';
import FormModal from '../FormModal';
import type { Ticket } from '../../api/ticket';
import type { UserOption } from '../../api/system';

export interface TicketAssignModalProps {
  /** 工单详情（标题展示工单号） */
  detail: Ticket | null;
  visible: boolean;
  saving: boolean;
  /** 所选处理人 id */
  assigneeId?: number;
  onAssigneeChange: (v?: number) => void;
  /** 派单选人候选（精简选人端点，无 PII） */
  users: UserOption[];
  onOk: () => void;
  onCancel: () => void;
}

/** 转派工单弹窗（选处理人）。 */
export default function TicketAssignModal({
  detail,
  visible,
  saving,
  assigneeId,
  onAssigneeChange,
  users,
  onOk,
  onCancel,
}: TicketAssignModalProps) {
  return (
    <FormModal
      title={`转派工单 #${detail?.id ?? ''}`}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={saving}
    >
      <Form layout="vertical">
        <Form.Item label="转派给" required>
          <Select
            showSearch
            placeholder="选择处理人"
            value={assigneeId}
            onChange={(v) => onAssigneeChange(v as number)}
            options={users.map((u) => ({ label: u.name || u.username, value: u.id }))}
          />
        </Form.Item>
      </Form>
    </FormModal>
  );
}
